import { postJangjiRecommendRequest } from "@/apis/sangjoQuotation";
import { isLoggedInState } from "@/atoms/accountState";
import { matchRequestFacilityLoadingState } from "@/atoms/match/matchRequestLoadingState";
import {
  장례진행중_GUIDEBOOK_PATH,
  장지유형_LIST,
  장지준비긴급도_LIST,
  장지핵심요소_LIST,
  장지희망서비스_LIST,
} from "@/containers/MatchContainer/constants/request";
import { FacilityMatchRequestProps } from "@/containers/MatchContainer/type/requestType";
import { useDialog } from "@/hooks/useDialog";
import { Box } from "@chakra-ui/react";
import {
  colors,
  cooKeys,
  customEvent,
  Dropdown,
  Field,
  FUNERAL_SIDO_LIST,
  FUNERAL_SIGUNGU,
  HStack,
  setCookie,
  Spacing,
  VStack,
} from "goi_common";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useReducer, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import RequestUniqueFixedButton from "../RequestUniqueFixedButton";

const SIDO_LIST = FUNERAL_SIDO_LIST.map((sido) => ({
  key: sido[1] as string,
  value: sido[0],
}));
function FacilityQuotationRequest({
  onlyFacility = false,
  isInline = false,
  eventPath = "facility_match_request",
}: {
  onlyFacility?: boolean;
  isInline?: boolean;
  eventPath?: "facility_match_request" | "facility_detail";
}) {
  const router = useRouter();

  const [selectFuneralSigungu, setSelectFuneralSigungu] = useState(true);
  const [selectFacilitySigungu, setSelectFacilitySigungu] = useState(true);
  const isLoggedIn = useRecoilValue(isLoggedInState);

  const { onOpen, onClose } = useDialog();
  const { onOpen: onOpenDialog, onClose: onCloseDialog } = useDialog();

  const [SelectedOption, setSelectedOption] = useReducer(
    (prev: FacilityMatchRequestProps, next: any) => {
      return { ...prev, ...next };
    },
    {
      장지만: "",
      장지준비긴급도: "",
      장지유형: "",
      핵심요소: "",
      희망서비스: "",
      funeral_sido: "",
      funeral_sigungu: "",
      facility_sido: "",
      facility_sigungu: "",
    },
  );

  const isDisabled = useMemo(() => {
    return (
      (onlyFacility ? false : !SelectedOption.장지만) ||
      !SelectedOption.장지준비긴급도 ||
      !SelectedOption.장지유형 ||
      !SelectedOption.핵심요소 ||
      !SelectedOption.희망서비스 ||
      !SelectedOption.funeral_sigungu ||
      !SelectedOption.facility_sigungu
    );
  }, [SelectedOption, onlyFacility]);

  useEffect(() => {
    if (SelectedOption.funeral_sido) {
      setSelectFuneralSigungu(false);
    }

    if (SelectedOption.funeral_sigungu) {
      setSelectFuneralSigungu(true);
    }

    if (SelectedOption.facility_sido) {
      setSelectFacilitySigungu(false);
    }

    if (SelectedOption.facility_sigungu) {
      setSelectFacilitySigungu(true);
    }
  }, [SelectedOption]);

  const handleSubmit = useCallback(async () => {
    if (loading) return;

    // 장례 진행중(장지 우선권이 상조팀에 있어 리드가 무의미)이면 견적 제출 대신 가이드북으로 이동
    const isFuneralInProgress =
      장지준비긴급도_LIST.find((item) => item.text === SelectedOption.장지준비긴급도)?.value ===
      "장례진행중";
    if (isFuneralInProgress) {
      router.push(장례진행중_GUIDEBOOK_PATH);
      return;
    }

    customEvent({
      newGtm: {
        path: eventPath,
        trigger_and_target: "submit_conversion",
      },
    });

    if (isDisabled) {
      onOpen({
        type: 1,
        closeOnOverlayClick: false,
        header: "응답하지 않은 항목이 있어요",
        children: <>다시 확인해주세요.</>,
        footerProps: {
          text: "확인",
          onClick: onClose,
        },
      });
      return;
    }

    try {
      setLoading(true);

      const body = {
        status: 장지준비긴급도_LIST.find((item) => item.text === SelectedOption.장지준비긴급도)
          ?.value as string,
        desired_type: 장지유형_LIST.find((item) => item.text === SelectedOption.장지유형)
          ?.value as string,
        most_important_factor: SelectedOption.핵심요소,
        additional_service: 장지희망서비스_LIST.find(
          (item) => item.text === SelectedOption.희망서비스,
        )?.value as string,
        origin_sido: SelectedOption.funeral_sido,
        origin_sigungu: SelectedOption.funeral_sigungu,
        jangji_sido: SelectedOption.facility_sido,
        jangji_sigungu: SelectedOption.facility_sigungu,
      };

      const { data, status } = await postJangjiRecommendRequest(body);
      if (status === 201) {
        customEvent({
          newGtm: {
            action: "match_request_complete",
          },
        });
        if (onlyFacility) {
          router.replace(`/match/facility-recommendation/`);
          return;
        }
        if (isLoggedIn) {
          router.push(`/match/facility-recommendation/`);
        } else {
          setCookie(cooKeys.quotation_request_facility, data);
          router.push(`/login?redirectTo=/match/facility-recommendation/`).then((res) => {
            setLoading(false);
            onClose();
          });
          // overlay.open(({ isOpen, close: onClose }) => {
          //   return (
          //     <OverlayModal
          //       onClose={onClose}
          //       isOpen={isOpen}
          //       modalContentStyle={{
          //         minWidth: "320px",
          //         overflow: "scroll",
          //       }}
          //       overlayModalContent={<ParlorCustomRequestModalContent onClose={onClose} />}
          //     />
          //   );
          // });
        }
      }
    } catch (e: any) {
      if (e.response && e.response.status === 500) {
        onOpenDialog({
          type: 1,
          closeOnOverlayClick: false,
          header: "이미 장지 견적을 받았어요",
          children: (
            <>
              작성해주신 견적서를 바탕으로 <br /> 상담이 진행중인 상태에요.
              <br /> 견적 내용을 수정하시려면,
              <br /> 카카오톡 채널로 문의주세요.
            </>
          ),
          footerProps: {
            text: "견적 확인",
            onClick: () => {
              router.push("/match/facility-recommendation/");
              onCloseDialog();
            },
          },
        });
      } else {
        console.log(e);
      }
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }, [SelectedOption]);

  const [loading, setLoading] = useRecoilState(matchRequestFacilityLoadingState);
  // const setResponseData = useSetRecoilState<any>(matchRequestResDataState);

  // const overlay = useOverlay();

  // const [, setTemporaryMatchRequest] = useRecoilState(temporaryMatchRequestState);
  return (
    <>
      <VStack padding="24px" width="100%">
        {isInline || (
          <Box
            width="100%"
            boxShadow="0px 0px 12px rgba(0, 0, 0, 0.12)"
            border={`1px solid ${colors.gray100}`}
            borderRadius="6px"
            background={colors.warmGray100}
            padding="16px"
            className="body3_r gray700"
          >
            서비스 추천은 한 번만 받아볼 수 있어요. 장례 서비스, 장례식장, 장지를 포함하여 전체
            서비스를 추천받으시려면 <b>한번에 추천받기</b>를 이용해보세요
          </Box>
        )}
        {!onlyFacility && (
          <>
            <Spacing gap={40} />

            <Field.ButtonGroups
              title={`장례서비스, 장례식장은 이미 결정하셨거나,\n장지만 알아보시는 상황인가요?`}
              items={["예", "아니오"]}
              value={SelectedOption.장지만}
              onChange={(e) => {
                setSelectedOption({ 장지만: e });
                customEvent({
                  newGtm: {
                    path: eventPath,
                    trigger_and_target: "jangji_only-answer",
                    text: e,
                  },
                });
                if (e === "아니오") {
                  onOpen({
                    type: 1,
                    closeOnOverlayClick: false,
                    header: "한번에 추천받아보세요",
                    children: (
                      <Box>
                        내 상황에 맞는 맞춤형 장례 서비스부터
                        <br />
                        장례식장 빈소 할인까지
                        <br />
                        함께 알아보시려면
                        <br />
                        {"[한번에 추천받기]를 이용하세요"}
                        <br />
                        <br />
                        장례 서비스, 장례식장, 장지까지
                        <br />
                        원스탑으로 도와드려요.
                      </Box>
                    ),
                    footerProps: [
                      {
                        text: "한번에 추천받기",
                        onClick: () => {
                          customEvent({
                            newGtm: {
                              path: eventPath,
                              trigger_and_target: "only_jangji_modal-tab_onestop",
                            },
                          });
                          router.replace("/match/request/");

                          onClose();
                        },
                      },
                      {
                        text: "장지만 추천받기",
                        onClick: () => {
                          customEvent({
                            newGtm: {
                              path: eventPath,
                              trigger_and_target: "only_jangji_modal-continue",
                            },
                          });
                          onClose();
                        },
                      },
                    ],
                  });
                  return;
                }
              }}
              flexDirection="row"
              buttonWidth="calc(50% - 4px)"
            />
          </>
        )}
        <Spacing gap={40} />

        <Field.Radio
          title="장지 준비가 급박한 상황인가요?"
          items={장지준비긴급도_LIST.map((item) => item.text)}
          value={SelectedOption.장지준비긴급도}
          onChange={(e) => {
            setSelectedOption({ 장지준비긴급도: e });
            customEvent({
              newGtm: {
                path: eventPath,
                trigger_and_target: "jangji_status-answer",
                text: String(e),
              },
            });
          }}
          radioWidth="100%"
          flexDirection="column"
        />

        <Spacing gap={40} />

        <Field.Radio
          title="희망하시는 장지 유형이 있으신가요?"
          items={장지유형_LIST.map((item) => item.text)}
          value={SelectedOption.장지유형}
          onChange={(e) => {
            setSelectedOption({ 장지유형: e });
            customEvent({
              newGtm: {
                path: eventPath,
                trigger_and_target: "jangji_type-answer",
                text: String(e),
              },
            });
          }}
          radioWidth="100%"
          flexDirection="column"
        />
        <Spacing gap={40} />

        <Field.Radio
          title="가장 중요하게 생각하시는 부분이 무엇인가요?"
          items={장지핵심요소_LIST}
          value={SelectedOption.핵심요소}
          onChange={(e) => {
            setSelectedOption({ 핵심요소: e });
            customEvent({
              newGtm: {
                path: eventPath,
                trigger_and_target: "jangji_important_factor-answer",
                text: String(e),
              },
            });
          }}
          radioWidth="100%"
          flexDirection="column"
        />
        <Spacing gap={40} />
        <Field.Radio
          title="희망하시는 추가 서비스가 있으신가요?"
          items={장지희망서비스_LIST.map((item) => item.text)}
          value={SelectedOption.희망서비스}
          onChange={(e) => {
            setSelectedOption({ 희망서비스: e });
            customEvent({
              newGtm: {
                path: eventPath,
                trigger_and_target: "jangji_desired_service-answer",
                text: String(e),
              },
            });
          }}
          radioWidth="100%"
          flexDirection="column"
        />
        <Spacing gap={48} />

        <VStack gap="16px" position="relative">
          <Box className="subtitle2_sb gray900">
            어디에서 장례를 치를 계획이신가요? (장례식장 위치)
            <br />
            <span className="body_16_m gray700">
              이장, 개장의 경우 현재 장지의 위치를 알려주세요.
            </span>
          </Box>

          <HStack gap="12px">
            <Dropdown
              name="지역"
              value={SelectedOption.funeral_sido}
              values={SIDO_LIST}
              onChange={(v) => {
                setSelectedOption({ funeral_sido: v, funeral_sigungu: undefined });
                customEvent({
                  newGtm: {
                    path: eventPath,
                    trigger_and_target: "facility_funeral_sido-answer",
                    text: String(v),
                  },
                });
              }}
            />
            <Dropdown
              name="지역"
              value={SelectedOption.funeral_sigungu}
              values={
                SelectedOption.funeral_sido
                  ? Array.from(FUNERAL_SIGUNGU.get(SelectedOption.funeral_sido)!).map(
                      (sigungu) => ({
                        key: sigungu[1],
                        value: sigungu[0],
                      }),
                    )
                  : []
              }
              onChange={(v) => {
                setSelectedOption({ funeral_sigungu: v });
                customEvent({
                  newGtm: {
                    path: eventPath,
                    trigger_and_target: "facility_funeral_sigungu-answer",
                    text: String(v),
                  },
                });
              }}
            />
          </HStack>
          {selectFuneralSigungu || (
            <div
              css={{ position: "absolute", bottom: -30, left: 5, zIndex: -1 }}
              className="orange650 button"
            >
              다음 지역을 선택해주세요.
            </div>
          )}
        </VStack>

        <Spacing gap={48} />

        <VStack gap="16px" position="relative">
          <Box className="subtitle2_sb gray900">(장지) 어느 지역에 모시고자 하시나요?</Box>

          <HStack gap="12px" zIndex={0}>
            <Dropdown
              name="지역"
              value={SelectedOption.facility_sido}
              values={SIDO_LIST}
              onChange={(v) => {
                setSelectedOption({ facility_sido: v, facility_sigungu: undefined });
                customEvent({
                  newGtm: {
                    path: eventPath,
                    trigger_and_target: "facility_sido-answer",
                    text: String(v),
                  },
                });
              }}
            />
            <Dropdown
              name="지역"
              value={SelectedOption.facility_sigungu}
              values={
                SelectedOption.facility_sido
                  ? Array.from(FUNERAL_SIGUNGU.get(SelectedOption.facility_sido)!).map(
                      (sigungu) => ({
                        key: sigungu[1],
                        value: sigungu[0],
                      }),
                    )
                  : []
              }
              onChange={(v) => {
                setSelectedOption({ facility_sigungu: v });
                customEvent({
                  newGtm: {
                    path: eventPath,
                    trigger_and_target: "facility_sigungu-answer",
                    text: String(v),
                  },
                });
              }}
            />
          </HStack>
          {selectFacilitySigungu || (
            <div
              css={{ position: "absolute", bottom: -30, left: 5, zIndex: -1 }}
              className="orange650 button"
            >
              다음 지역을 선택해주세요.
            </div>
          )}
        </VStack>
        <Spacing gap={isInline ? 200 : 300} />
      </VStack>

      <RequestUniqueFixedButton
        isFixed={!isInline}
        disabled={isDisabled}
        handleSubmit={handleSubmit}
        loading={loading}
      />
    </>
  );
}

export default FacilityQuotationRequest;
